/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize PsychosocialRisk View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PsychosocialRiskView';

export const mapStateToPropsPsychosocialRisk = mapStateToProps;
export const mapDispatchToPropsPsychosocialRisk = mapDispatchToProps;

export default connect(
  mapStateToPropsPsychosocialRisk,
  mapDispatchToPropsPsychosocialRisk
)(View);
